export const useCookies = () => {
  const getCookie = (name) => {
    const matches = document.cookie.match(
      new RegExp(
        '(?:^|; )' +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
          '=([^;]*)', // eslint-disable-line
      ),
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  const setCookie = (name, days, cookieValue) => {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    const newValue = cookieValue ? cookieValue : new Date().getTime();

    document.cookie =
      name + '=' + (newValue || '') + expires + '; path=/; secure';
  };

  const expireCookie = (name) => {
    document.cookie =
      name + '= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
  };

  return {
    getCookie,
    setCookie,
    expireCookie,
  };
};
